import {
    Widget,
    WidgetDescription,
    Connector,
    Unmounter,
    Renderer,
    UnknownWidgetParams,
} from 'instantsearch.js/es/types'

import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'

import { noop } from '@app-lib/common.lib'
import { InstantsearchComponent } from '@app-domains/instantsearch/components/instantsearch.component'

export { Widget, Connector }

type AdditionalWidgetProperties = Partial<Widget<WidgetDescription>>

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export abstract class AbstractInstantsearchWidgetComponent<
    TWidgetDescription extends WidgetDescription,
    TConnectorParams extends UnknownWidgetParams,
> implements OnInit, OnDestroy {

    @Input()
    public autoHideContainer?: boolean

    // Todo: remove non-null assertion
    public widget?: Widget

    public state?: TWidgetDescription['renderState']


    public abstract readonly widgetName: string
    public abstract instantSearchInstance: InstantsearchComponent

    public createWidget(
        connector: Connector<TWidgetDescription, TConnectorParams>,
        options: TConnectorParams,
        additionalWidgetProperties: AdditionalWidgetProperties = {},
    ) {
        this.widget = {
            ...connector(this.updateState, noop as Unmounter)(options),
            ...additionalWidgetProperties,
        }
    }

    public ngOnInit() {
        this.instantSearchInstance.addWidgets([this.widget!]) // Todo: remove non-null assertion
    }

    public ngOnDestroy() {
        if (isPlatformBrowser(this.instantSearchInstance.platformId)) {
            this.instantSearchInstance.removeWidgets([this.widget!]) // Todo: remove non-null assertion
        }
    }

    public updateState: Renderer<TWidgetDescription['renderState'], TConnectorParams> = (state, isFirstRendering) => {
        if (isFirstRendering) {
            Promise.resolve()
                .then(() => this.state = state)
        } else {
            this.state = state
        }
    }


}
